import Plyr from 'plyr';

// Omit settings: Plyr leaves role="menu" regions empty when quality/speed/captions
// have no options (typical HTML5), which WAVE flags. Captions stay on the captions control.
// Tooltip colors: only tooltips.controls / tooltips.seek in Plyr(); contrast via SCSS vars.
const plyrDefaults = {
	settings: [],
	controls: [
		'play-large',
		'play',
		'progress',
		'current-time',
		'mute',
		'volume',
		'captions',
		'fullscreen',
	],
};

document.addEventListener('DOMContentLoaded', function () {
	const elms = document.querySelectorAll(
		'[data-plyr] > *, [data-plyr], .wp-block-video video, .wp-block-media-text__media video'
	);

	for (let i = 0; i < elms.length; i++) {
		new Plyr(elms[i], plyrDefaults);
	}
});
